<template>
  <header class="header-top">
    <head-bar :headData="headData"></head-bar>
    <nav-bar :navs="navList"></nav-bar>
  </header>
</template>

<script>
import merge from "webpack-merge";
import HeadBar from "./HeadBar";
import NavBar from "./NavBar";

export default {
  name: "index",
  data() {
    return {
      navList: [
        {
          name: "首页",
          link: "/",
          isImg: false,
          imgUrl: "",
        },
        {
          name: "买车",
          link: "/m/home/buycar",
          isImg: false,
          imgUrl: "",
        },
        {
          name: "团车活动",
          link: "/m/activity/index",
          isImg: true,
          imgUrl: require("../../assets/img/header/tchd.png"),
        },
        // {
        //   name: "团车金融",
        //   link: "/m/home/finance",
        //   isImg: false,
        //   imgUrl: "",
        // },
        {
          name: "经销商活动",
          link: "/m/dealer/index",
          isImg: false,
          imgUrl: "",
        },
      ],
      headData: {
        cityName: "",
        searchUrl: this.url.mTuancheCom + "buynewcar/search",
        usersUrl:
          this.url.mTuancheCom +
          "usercenter?homeUrl=" +
          this.url.api.WAP_TUANCHE_COM,
        // +"&goto="+window.location.href
      },
    };
  },
  mounted() {
    let self = this;
    let cityPy = this.getQueryString("cityPy");
    this.cityInfo.init(cityPy).then(function (v) {
      self.headData.cityName = v.name;
      if (cityPy) {
        self.$router.push({
          query: merge(self.$route.query, { cityPy: v.py }),
        });
      }
      // 如果存在广告变量, 则调用方法设置城市id
      if (window.Advertjs) window.Advertjs.setCity(v.id);
    });
  },
  methods: {
    /*获取地址栏参数*/
    getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    },
  },
  components: {
    HeadBar,
    NavBar,
  },
};
</script>

<style lang="less" scoped>
.header-top {
  position: fixed;
  top: 0;
  left: 0;
  background: #ffffff;
  width: 100%;
  z-index: 1000;
}
</style>


// WEBPACK FOOTER //
// src/components/header/Index.vue